import { render, staticRenderFns } from "./TransportationPermissionListItem.vue?vue&type=template&id=560dd586"
import script from "./TransportationPermissionListItem.vue?vue&type=script&lang=ts"
export * from "./TransportationPermissionListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports